// extracted by mini-css-extract-plugin
export var toastContainer = "ToastContainer_toastContainer__d0zpy";
export var rotate = "ToastContainer_rotate__BEq+8";
export var dotty = "ToastContainer_dotty__S5YwN";